import { AmountUsd } from '@ui/components/Amount/AmountUsd';
import { useLiqPriceAfterSpread } from '@ui/features/Trade/hooks/useLiqPriceAfterSpread';
import { useTokenDisplayDecimals } from '@ui/hooks/useTokenDisplayDecimals';
import { Text } from '@ui/lib/park/ui/text';
import { useTranslation } from 'next-i18next';

import { useTradingPair } from '../../store/useTradingPair';

export const LiqPrice = () => {
  const { t } = useTranslation();

  const liqPrice = useLiqPriceAfterSpread();
  const currentTradePairInfo = useTradingPair((s) => s.useTradingPair());
  const priceDisplayDecimals = useTokenDisplayDecimals(
    currentTradePairInfo?.baseSymbol,
    currentTradePairInfo?.priceDisplayDecimals,
  );

  return (
    <>
      <Text>{t('common.Liquidation')}</Text>
      <AmountUsd
        textAlign="end"
        color="greyWhite.lightGrey1"
        value={liqPrice}
        opts={{
          displayDecimals: priceDisplayDecimals,
        }}
        data-cy="LiqPrice"
        data-cy-value={liqPrice}
      />
    </>
  );
};
